<app-loader *ngIf="isDisabled || isPageDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="SeperationPoliciesForm" (ngSubmit)="Validate(SeperationPoliciesForm)"
        #SeperationPoliciesForm="ngForm" novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Exit Policy
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="RegularizationRuleTitle" class="form-label text-label-dark">Policy Name
                                :</label>
                        </div>
                        <div class="col-md-5">
                            <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Name"
                                id="RegularizationRuleTitle" name="RegularizationRuleTitle"
                                [(ngModel)]="RegularizationRuleDetail.RegularizationRuleTitle"
                                #RegularizationRuleTitle="ngModel" maxlength="100" required>
                            <div class="invalid-feedback">
                                Please Enter Policy Name!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto">
                            <label for="EmpType" class="form-label text-label-dark">Employee Type :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.RegularizationRuleDetail.ESS_RegularizationRuleID == 0) || (this.RegularizationRuleDetail.ESS_RegularizationRuleID > 0 && common.ToLowerCase(RegularizationRuleDetail.EmpType) == 'front')">
                                    <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                        [(ngModel)]="RegularizationRuleDetail.EmpType"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="RegularizationRuleDetail.ESS_RegularizationRuleID > 0"
                                        (change)="GetApplicability()" required>
                                    Front Office
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.RegularizationRuleDetail.ESS_RegularizationRuleID == 0) || (this.RegularizationRuleDetail.ESS_RegularizationRuleID > 0 && common.ToLowerCase(RegularizationRuleDetail.EmpType) == 'back')">
                                    <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                        [(ngModel)]="RegularizationRuleDetail.EmpType"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="RegularizationRuleDetail.ESS_RegularizationRuleID > 0"
                                        (change)="GetApplicability()" required>
                                    Back Office
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center me-2">
                            <label for="DefaultRegularization" class="form-label text-label-dark">Default Policy
                                :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="DefaultRegularization"
                                        [(ngModel)]="RegularizationRuleDetail.DefaultRegularization"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="DefaultRegularization"
                                        [(ngModel)]="RegularizationRuleDetail.DefaultRegularization"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="IsRegularizationForFutureDate" class="form-label text-label-dark">
                                Employee to suggest Last working day:</label>
                        </div>
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="IsRegularizationForFutureDate"
                                        [(ngModel)]="RegularizationRuleDetail.IsRegularizationForFutureDate"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="IsRegularizationForFutureDate"
                                        [(ngModel)]="RegularizationRuleDetail.IsRegularizationForFutureDate"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                        <!-- <div class="col-md-2">
                            <div class="input-group mb-3">
                                <input type="text" maxlength="10"  
                                    (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                    placeholder="Ex. 01" id="ReportToBeSubmittedBefore"
                                    name="ReportToBeSubmittedBefore"
                                    [(ngModel)]="RegularizationRuleDetail.AllowRegularizationForDays"
                                    #ReportToBeSubmittedBefore="ngModel" 
                                    [disabled]="!RegularizationRuleDetail.IsRegularizationForFutureDate"
                                     >
                                <span class="input-group-text" id="basic-ReportToBeSubmittedBefore">day</span>
                                 
                            </div>
                        </div> -->
                    </div>
                    <div class="row ms-5">
                        <div class="col-md-5">
                            <div class="btn-group d-grid">
                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="IsAllowRequestsForFutureDates">
                                        <label class="form-check-label text-label-light"
                                            for="IsAllowRequestsForFutureDates">
                                            Past Last Working date limit
                                        </label>
                                    </span>
                                    <input type="text" maxlength="5" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                        placeholder="Ex. 01" id="FutureDateRequestLimit" name="FutureDateRequestLimit"
                                        [(ngModel)]="RegularizationRuleDetail.AllowRegularizationFor"
                                        #FutureDateRequestLimit="ngModel"
                                        [disabled]="!RegularizationRuleDetail.IsRegularizationForFutureDate" required>
                                    <span class="input-group-text" id="basic-limit">days </span>
                                    <div class="invalid-feedback">
                                        Please enter days.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row ms-5">
                        <div class="col-md-5">
                            <div class="btn-group d-grid">
                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="IsAllowRequestsForFutureDates">
                                        <label class="form-check-label text-label-light"
                                            for="IsAllowRequestsForFutureDates">
                                            Future Last Working date limit
                                        </label>
                                    </span>
                                    <input type="text" maxlength="5" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                        placeholder="Ex. 01" id="FutureDateRequestLimit" name="FutureDateRequestLimit"
                                        [(ngModel)]="RegularizationRuleDetail.AllowRegularizationFor"
                                        #FutureDateRequestLimit="ngModel"
                                        [disabled]="!RegularizationRuleDetail.IsRegularizationForFutureDate" required>
                                    <span class="input-group-text" id="basic-limit">days </span>
                                    <div class="invalid-feedback">
                                        Please enter days.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="IsRegularizationForFutureDate" class="form-label text-label-dark">
                                Backdate Exit:</label>
                        </div>
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="AllowRegularizationForSameDays"
                                        [(ngModel)]="RegularizationRuleDetail.AllowRegularizationForSameDays"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="AllowRegularizationForSameDays"
                                        [(ngModel)]="RegularizationRuleDetail.AllowRegularizationForSameDays"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row ms-5">
                        <div class="col-md-5">
                            <div class="btn-group d-grid">
                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="IsAllowRequestsForFutureDates">
                                        <label class="form-check-label text-label-light"
                                            for="IsAllowRequestsForFutureDates">
                                            Backdate seperation date limit
                                        </label>
                                    </span>
                                    <input type="text" maxlength="5" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                        placeholder="Ex. 01" id="FutureDateRequestLimit" name="FutureDateRequestLimit"
                                        [(ngModel)]="RegularizationRuleDetail.AllowRegularizationFor"
                                        #FutureDateRequestLimit="ngModel"
                                        [disabled]="!RegularizationRuleDetail.AllowRegularizationForSameDays" required>
                                    <span class="input-group-text" id="basic-limit">days </span>
                                    <div class="invalid-feedback">
                                        Please enter days.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="RegularizationRuleDetail.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()"
                                        [disabled]="Applicability.WebESSApplicabilityMasterID == 0 && RegularizationRuleDetail.DefaultRegularization">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && RegularizationRuleDetail.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>
                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>